

import * as React from "react"
import * as ReactDOM from "react-dom"
import { FormattedNumber, IntlProvider, addLocaleData } from "react-intl"
import { RentalAdvertPricing } from '../../../types/types'

type Props = {
  pricing: RentalAdvertPricing
  onPriceClick: () => void
}

type State = {
}

declare var window: { Gites: { locale: string }};

export default class Price extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
    }

  }

  renderWithPrice() : JSX.Element {
    return <div>
      <div className="conversion-box--from">
        {this.props.pricing.priceLabel}
      </div>
      <div className="conversion-box__price" onClick={() => this.props.onPriceClick()}>
        <FormattedNumber
          value={this.props.pricing.price}
          style="currency"
          currency="EUR"
        />
      </div>
    </div>
  }

  renderWithoutPrice() : JSX.Element {
    return <div className="conversion-box__price--unknown">
      <div onClick={() => this.props.onPriceClick()}>
        {this.props.pricing.priceLabel}
      </div>
    </div>
  }

  render() {
    return (
      <IntlProvider locale={window.Gites.locale}>
        {this.props.pricing.price ? this.renderWithPrice() : this.renderWithoutPrice() }
      </IntlProvider>
    )
  }
}
